export enum EFormControl {
    text = 'text',
    textV2 = 'textV2',
    password = 'password',
    passwordV2 = 'passwordV2',
    textArea = 'textArea',
    textAreaV2 = 'textAreaV2',
    checkbox = 'checkbox',
    checkboxV2 = 'checkboxV2',
    checkboxGroup = 'checkboxGroup',
    select = 'select',
    selectV2 = 'selectV2',
    treeSelect = 'treeSelect',
    numeric = 'numeric',
    numericV2 = 'numericV2',
    multiSelect = 'multiSelect',
    multiSelectV2 = 'multiSelectV2',
    email = 'email',
    radioGroup = 'radioGroup',
    uploadImage = 'uploadImage',
    orSwitch = 'orSwitch',
    switch = 'switch',
    phoneNumber = 'phoneNumber',
    phoneNumberV2 = 'phoneNumberV2',
    datePicker = 'datePicker',
    rangePicker = 'rangePicker',
    inputLoqate = 'inputLoqate',
    getAddressIO = 'getAddressIO',
    address = 'address',
    timePicker = 'timePicker',
    transfer = 'transfer',
}
